import React, { ReactNode } from 'react'

export const listOfRoles: Record<Role, Role> = {
    admin: 'admin',
    nsp: 'nsp',
    location_qa: 'location_qa',
    location_manager: 'location_manager',
    corporate_quality_board: 'corporate_quality_board',
    corporate_quality_management: 'corporate_quality_management',
    unit_general_manager: 'unit_general_manager'
}
export const roleToName = {
    admin: 'Administrador',
    nsp: 'NSP',
    location_qa: 'Qualidade da unidade',
    location_manager: 'Gestor da unidade',
    corporate_quality_board: 'Diretoria Qualidade Corporativa',
    corporate_quality_management: 'Gestão Qualidade Corporativa',
    unit_general_manager: 'Diretor Geral Unidade'
}
export const allRolesList: Role[] = [
    listOfRoles.admin,
    listOfRoles.nsp,
    listOfRoles.location_qa,
    listOfRoles.location_manager,
    listOfRoles.corporate_quality_board,
    listOfRoles.corporate_quality_management,
    listOfRoles.unit_general_manager
]

export type Role =
    | 'admin'
    | 'nsp'
    | 'location_qa'
    | 'location_manager'
    | 'corporate_quality_board'
    | 'corporate_quality_management'
    | 'unit_general_manager'

const WithRoleAuthorization: React.FC<{
    allowedRoles: Role[]
    userRole: Role
    children: JSX.Element
}> = ({ allowedRoles, userRole, children }) => {
    const hasRole = (): boolean => {
        return allowedRoles.includes(userRole)
    }
    return hasRole() ? children : null
}

export default WithRoleAuthorization
